<style lang="scss">
  @import './index.scss';
</style>
<template>
    <div class="account">
        <div class="account-header">
            <h1>{{ $t('accountAuthorization.title') }}</h1>
        </div>
        <div class="account-content">
            <div class="account-content-operate">
                <i-button type="primary" icon="md-add" class="account-create" @click="createNewUser">{{ $t('accountAuthorization.createNewUser') }}</i-button>
                <i-input icon="ios-search" v-model="key" :placeholder="$t('filter.search')" style="width:160px" class="account-search" @keyup.native="getSearchData"></i-input>
                <i-button ghost-tmp class="account-del" @click="delUser" :disabled="selection.length == 0">
                  <i class="iconfont icon-del account-del-icon"></i>
                  {{ $t('accountAuthorization.delete') }}
                </i-button>
            </div>
            <i-table :columns="tableColumns" :data="tableData" :no-data-text="noData" class="account-table" @on-selection-change="selectionRow">
            </i-table>
            <div class="page-wrap">
              <div class="pageOpts">
                  <i-select v-model="pageSize" style="width:80px;" @on-change="changePage(1)">
                      <i-option v-for="item in pageSizeOpts" :value="item" :key='item'>{{item}}{{ $t('accountAuthorization.pagesize') }}</i-option>
                  </i-select>
              </div>
              <div class="page">
                  <Page :total="pages" :current="curPage" :page-size="pageSize" :page-size-opts="pageSizeOpts" @on-change="changePage"></Page>
              </div>
            </div>
        </div>
        <Modal v-model="modalShow" @on-ok="delSelectUser" @on-cancel="cancel">
            <p class="manage-event-paragraph">{{$t('accountAuthorization.del')}}</p>
        </Modal>
    </div>
</template>
<script>
import bus from '../../libs/bus';
import util from '../../libs/util';

export default {
  props: {},
  data() {
    return {
      key: '',
      token: bus.token,
      tableColumns: [],
      tableData: [],
      noData: this.$t('common.loading'),
      list: [],
      selection: [],
      modalShow: false,
      pages: 0,
      curPage: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
    };
  },
  methods: {
    init() {
      this.tableColumns = this.getColumns();
      this.getData();
    },
    // 获取表头
    getColumns() {
      const self = this;
      const list = [{
        type: 'selection',
        key: 'selectStyle',
        width: 48,
      }, {
        key: 'licensee',
        title: self.$t('accountAuthorization.username'),
      }, {
        key: 'role',
        title: self.$t('accountAuthorization.role'),
        render(h, params) { // 判断创建者or普通用户or渠道合作伙伴
          let role = '';
          if (params.row.roletype === 0 || params.row.roletype === 1) {
            role = self.$t('accountAuthorization.ordinaryuser');
          } else if (params.row.roletype === 2) {
            role = self.$t('accountAuthorization.partneruser');
          }
          if (params.row.licensee === bus.username) {
            role = self.$t('accountAuthorization.creator');
          }
          return h('span', role);
        },
      }, {
        key: 'remarks',
        title: self.$t('accountAuthorization.remarks'),
        render(h, params) {
          if (params.row.remarks) {
            return h('span', params.row.remarks);
          }
          return h('span');
        },
      }, {
        key: 'authorizedtime',
        title: self.$t('accountAuthorization.createtime'),
      }, {
        key: 'operate',
        title: self.$t('accountAuthorization.operate'),
        width: 90,
        render(h, params) {
          const remark = params.row.remarks ? params.row.remarks : '';
          return h('i', {
            class: 'iconfont icon-edit account-opreate-modify',
            props: {
              size: 16,
            },
            on: {
              click: () => {
                self.goEditAuthorization(params.row.licensee,
                  params.row.authorizedid, remark, params.row.roletype);
              },
            },
          });
        },
      }];
      return list;
    },
    // 处理表格数据
    getTableData(filterRes) {
      const cur = this.curPage;
      const size = this.pageSize;
      this.pages = filterRes.length;

      const start = (cur - 1) * size;
      let offset = size;
      if (cur * size >= filterRes.length) {
        offset = filterRes.length - start;
      }
      const result = [];
      for (let i = start; offset > 0; i++) {
        result.push(filterRes[i]);
        offset--;
      }

      this.tableData = result;
      if (result.length === 0) {
        this.noData = this.$t('common.nodata');
      }
    },
    // 获取数据
    getData() {
      const params = {
        pageid: `authorizedAccount_${this.token}`,
      };
      util.ajax.get('/app/rest/authorized.json/getAccount', { params }).then((res) => {
        let flog = false;
        const data = res;
        for (let i = 0; i < data.length; i++) { // 给创建者添加class隐藏其checked
          if (data[i].licensee === bus.username) {
            flog = true;
            data[i].cellClassName = {
              selectStyle: 'account-checked-dis',
              operate: 'account-user-operate',
            };
          }
        }
        if (!flog) {
          const c = {};
          c.licensee = bus.username;
          c.authorizedtime = bus.userReg;
          c.cellClassName = {
            selectStyle: 'account-checked-dis',
            operate: 'account-user-operate',
          };
          data.push(c);
        }
        this.pages = data.length;
        this.list = data;
        this.getSearchData();
      });
    },
    // 切换页码
    changePage(index) {
      this.curPage = index;
      this.getSearchData(index);
    },
    /**
     * 获取检索后数据
     * @param index, index为Object表示搜索框触发的此函数，index为Number表示改变页码触发的此函数，
     index为空，表示ajax数据获取后触发的此函数
     **/
    getSearchData(index) {
      const data = this.list;
      const key = this.key.toLowerCase();
      if (this.key === '') {
        this.getTableData(data);
        return;
      }
      this.curPage = typeof (index) === 'object' || !index ? 1 : index;
      const result = [];
      let tempData;
      for (let i = 0; i < data.length; i++) {
        tempData = data[i];
        if (tempData.licensee.toLowerCase().indexOf(key) > -1 ||
          (tempData.remarks && tempData.remarks.toLowerCase().indexOf(key) > -1)) {
          result.push(data[i]);
        }
      }
      this.total = result.length;
      this.getTableData(result);
    }, // 获取选中列
    selectionRow(row) {
      this.selection = row;
    },
    // 删除用户对话框
    delUser() {
      if (this.selection.length > 0) {
        this.modalShow = true;
      }
    },
    // 创建新用户
    createNewUser() {
      if (bus.demoTip()) return;
      const authorInfo = {
        operation: 1, // 操作 1为新建账户， 2为编辑账户
        roletype: 1,
      };
      bus.authorinfo = authorInfo;
      // sessionStorage.setItem('td-account-authorInfo', JSON.stringify(authorInfo));
      this.$router.push({
        name: 'editAuthorization',
     // params:{ 'authorizedid':authorid }
      });
    },
    // 删除用户
    delSelectUser() {
      const authorized = [];
      const data = this.selection;
      for (let i = 0; i < data.length; i++) { // 过滤创建者
        if (data[i].licensee !== bus.username) {
          authorized.push(data[i].authorizedid);
        }
      }
      const tabData = this.tableData;
      for (let j = 0; j < authorized.length; j++) {
        for (let k = 0; k < tabData.length; k++) {
          if (authorized[j] === tabData[k].authorizedid) {
            tabData.splice(k, 1);
//            continue;
          }
        }
      }
      this.selection = [];
      this.delDatabaseUser(authorized, 0);
    },
    delDatabaseUser(authorzedid, index) {
      if (index < authorzedid.length) {
        const params = {
          authorizedid: authorzedid[index],
          pageid: `authorizedAccount_${this.token}`,
        };
        util.ajax.get('/app/rest/authorized.json/deleteAccount', { params })
        .then(() => {
          this.delDatabaseUser(authorzedid, index + 1);
          if (index + 1 === authorzedid.length) {
            this.getData();
          }
        });
      }
    },
    cancel() {},
    /**
     * @param licensee {String} 用户名
     * @param authorized {Number} 用户id
     * @param remark {String} 备注
     * @param role {Number} 1为普通用户 2为渠道合作伙伴
    */
    goEditAuthorization(licensee, authorized, remark, role) {
      const authorInfo = {
        operation: 2, // 操作   1为新建账户， 2为编辑账户
        email: licensee,
        authorizedid: authorized,
        remarks: remark || '',
        roletype: role,
      };
//              sessionStorage.setItem('td-account-authorInfo', JSON.stringify(authorInfo));
      bus.authorinfo = authorInfo;
      this.$router.push({
        name: 'editAuthorization',
//                  params:{ 'authorizedid':authorid }
      });
    },
  },
  computed: {
    language() {
      return bus.lang;
    },
  },
  watch: {
    language() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
